import { createFileRoute } from '@tanstack/react-router'

import { Frame } from '@/components/frame'
import { PageHeader } from '@/components/page-header'
import { parseQuotesSearch } from '@/components/quotes/quotes-search-schema'
import { QuotesWorkspace } from '@/components/quotes/quotes-workspace'

/** Liste des soumissions (lot 14, #208) : filtres dans l'URL, tableau dans son cadre. */
export const Route = createFileRoute('/_app/quotes/')({
  validateSearch: parseQuotesSearch,
  component: QuotesPage,
})

function QuotesPage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <div className="space-y-6">
      <PageHeader title="Soumissions" documentTitle="Soumissions" />
      <Frame>
        <QuotesWorkspace
          search={search}
          onSearchChange={(next) => {
            void navigate({ search: (current) => ({ ...current, ...next }) })
          }}
        />
      </Frame>
    </div>
  )
}
